import React from "react";
import styles from "./StepIndicator.module.css";

const CheckmarkIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 15L3 10L4.41 8.59L8 12.17L15.59 4.58L17 6L8 15Z"
      fill="currentColor"
    />
  </svg>
);

interface StepIndicatorProps {
  steps: string[];
  activeStep: number;
}

function StepIndicator({ steps, activeStep }: StepIndicatorProps) {
  return (
    <div className={styles.container}>
      {steps.map((step, index) => (
        <div key={index} className={styles.stepWrapper}>
          {index < steps.length - 1 && (
            <div
              className={`${styles.connectorLine} ${
                index < activeStep ? styles.completed : ""
              }`}
            />
          )}
          <div
            className={`${styles.stepNumber} ${
              index + 1 === activeStep
                ? styles.active
                : index + 1 < activeStep
                  ? styles.completed
                  : ""
            }`}
          >
            {index < activeStep ? <CheckmarkIcon /> : index + 1}
          </div>
          <span
            className={`${styles.stepLabel} ${
              index + 1 === activeStep
                ? styles.active
                : index + 1 < activeStep
                  ? styles.completed
                  : ""
            }`}
          >
            {step}
          </span>
        </div>
      ))}
    </div>
  );
}

export default StepIndicator;
